module.exports = __webpack_public_path__ + "img/microphone.cf097567.svg";